import type {PropsWithChildren} from 'react';
import {WebsocketContext, useWebsocketConnection} from '@chekin/shared/payments';
import {useChekinSDK} from '../ChekinSDK';

function WebsocketProvider({children}: PropsWithChildren) {
  const {isTokenValid, mainToken} = useChekinSDK();
  const value = useWebsocketConnection(Boolean(mainToken && isTokenValid));

  return <WebsocketContext.Provider value={value}>{children}</WebsocketContext.Provider>;
}

export {WebsocketProvider};
